import { FC, Fragment } from 'react';
import classnames from 'classnames';
import Icon from '../ui/Icon';
import Divider from './Divider';
import { useDarkModeContext } from './PDP/DarkModeContext/useDarkModeContext';

type CreditCalloutProps = {
  items: string[];
  handleDarkMode?: boolean;
  showDividers?: boolean;
  classNames?: string;
};
const CreditCallout: FC<CreditCalloutProps> = ({
  items,
  handleDarkMode,
  showDividers,
  classNames
}) => {
  const darkmodeContext = useDarkModeContext();
  const isDarkMode = !!handleDarkMode && !!darkmodeContext?.isDarkMode;

  return items?.map((item, idx) => (
    <Fragment key={idx}>
      <span
        className={classnames(
          classNames,
          { 'text-silver': isDarkMode },
          'text-2 inline-flex items-center py-1 text-gray-dark'
        )}
      >
        <Icon size="small" name="approved" className="mr-1.5" aria-label="Approved Credit Status" />
        {item}
      </span>
      {!!showDividers && idx < items.length - 1 && (
        <Divider
          color={isDarkMode ? 'light' : 'dark'}
          orientation="vertical"
          length={16}
          className="mx-3"
        />
      )}
    </Fragment>
  ));
};
export default CreditCallout;
